.subtotal-container {
  border-top: 1px solid var(--default--border-color--10);
  display: flex;
  justify-content: flex-end;
  font-size: 13px;
  padding: 10px 0;
  font-weight: var(--font-weight-bold);
  margin: 0 35px;
}
